import { call, takeLatest, all } from 'redux-saga/effects';

import {
  getPlainLanguages,
  createLanguage,
  editLanguage,
  deleteLanguage,
  getTranslations,
  addTranslations,
  editTranslations,
  clearTranslations,
  importTranslations,
  getImportTranslationsStatus,
} from 'api/languages';
import { LANGUAGES_ACTION_TYPES } from 'store/actions/languages.actions';

function* loadPlainLanguagesFlow(action) {
  const { resolve, reject } = action;
  try {
    const { data: response } = yield call(getPlainLanguages);
    resolve(response);
  } catch (e) {
    reject(e);
  }
}

function* createLanguageFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(createLanguage, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* editLanguageFlow(action) {
  const { payload, resolve, reject } = action;
  const { id, ...rest } = payload;
  try {
    const { data } = yield call(editLanguage, id, rest);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* deleteLanguageFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data: response } = yield call(deleteLanguage, payload);
    resolve(response);
  } catch (e) {
    reject(e);
  }
}

function* loadTranslationsFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(getTranslations, payload);
    resolve({ items: data['hydra:member'], total: data['hydra:totalItems'] });
  } catch (e) {
    reject(e);
  }
}

function* addTranslationsFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { identifier, ...rest } = payload;
    const { data } = yield call(addTranslations, { key: identifier, translations: rest.translations });
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* editTranslationsFlow(action) {
  const { payload, resolve, reject } = action;
  const { id, identifier, translations } = payload;

  try {
    const { data } = yield call(editTranslations, id, { key: identifier, translations });
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* clearTranslationsFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(clearTranslations, payload);
    resolve(data);
  } catch (e) {
    reject(e.response.data);
  }
}

function* importTranslationsFlow(action) {
  const { resolve, reject } = action;
  try {
    const { data } = yield call(importTranslations);
    resolve(data);
  } catch (e) {
    reject(e?.response?.data);
  }
}

function* getImportTranslationsStatusFlow(action) {
  const { payload, resolve, reject } = action;
  try {
    const { data } = yield call(getImportTranslationsStatus, payload);
    resolve(data);
  } catch (e) {
    reject(e?.response?.data);
  }
}

function* watchLoadPlainLanguages() {
  yield takeLatest(LANGUAGES_ACTION_TYPES.LOAD_PLAIN_LANGUAGES, loadPlainLanguagesFlow);
}

function* watchCreateLanguage() {
  yield takeLatest(LANGUAGES_ACTION_TYPES.CREATE_LANGUAGE, createLanguageFlow);
}

function* watchEditLanguage() {
  yield takeLatest(LANGUAGES_ACTION_TYPES.EDIT_LANGUAGE, editLanguageFlow);
}

function* watchDeleteLanguage() {
  yield takeLatest(LANGUAGES_ACTION_TYPES.DELETE_LANGUAGE, deleteLanguageFlow);
}

function* watchLoadTranslations() {
  yield takeLatest(LANGUAGES_ACTION_TYPES.LOAD_TRANSLATIONS, loadTranslationsFlow);
}

function* watchEditTranslations() {
  yield takeLatest(LANGUAGES_ACTION_TYPES.EDIT_TRANSLATIONS, editTranslationsFlow);
}

function* watchAddTranslations() {
  yield takeLatest(LANGUAGES_ACTION_TYPES.ADD_TRANSLATIONS, addTranslationsFlow);
}

function* watchClearTranslations() {
  yield takeLatest(LANGUAGES_ACTION_TYPES.CLEAR_TRANSLATIONS, clearTranslationsFlow);
}

function* watchImportTranslations() {
  yield takeLatest(LANGUAGES_ACTION_TYPES.IMPORT_TRANSLATIONS, importTranslationsFlow)
}

function* watchGetImportTranslationsStatus() {
  yield takeLatest(LANGUAGES_ACTION_TYPES.GET_IMPORT_TRANSLATIONS_STATUS, getImportTranslationsStatusFlow)
}

export default function* () {
  yield all([
    watchLoadPlainLanguages(),
    watchCreateLanguage(),
    watchEditLanguage(),
    watchDeleteLanguage(),
    watchLoadTranslations(),
    watchEditTranslations(),
    watchAddTranslations(),
    watchClearTranslations(),
    watchImportTranslations(),
    watchGetImportTranslationsStatus(),
  ]);
}
